import React, { useState } from 'react';
import styled from 'styled-components';

import { SubscriptionTopic } from '../../../viewer/messaging/pubsub';
import { WmsState } from '../../../viewer/wms-state';
import { useSubscribe } from '../../hooks/use-subscribe';

export const useWmsAttributions = () => {
  const [attributions, setAttributions] = useState(WmsState.instance.attributions);
  useSubscribe(SubscriptionTopic.WmsAttributionsChanged, (data) => setAttributions(data));
  return attributions;
};

export const WmsAttributions = () => {
  const attributions = useWmsAttributions();

  if (attributions.length === 0) {
    return null;
  }

  // Setting the InnerHTML is generally not recommended. But we trust the WMS sources we have currently.
  // But if we ever let the user pick their own WMS source this becomes a security issue.
  return (
    <Component>
      {attributions.map((item, idx) => (
        <Attribution dangerouslySetInnerHTML={{ __html: item }} key={idx} />
      ))}
    </Component>
  );
};

const Attribution = styled.div`
  color: white;

  // Adust the color for hyperlinks agains the dark background
  a {
    &:link {
      color: #11f7ff;
    }
    &:visited {
      color: #ea84ec;
    }
  }
`;

const Component = styled.div`
  position: absolute;
  left: 0.4em;
  top: 0.4em;

  min-width: max-content;
  display: flex;
  font-size: 0.5em;
  flex-direction: row;
  gap: 0.5em;
  padding: 0.2em;
  background: rgba(0, 0, 0, 0.75);
`;
